import script from "./ChangeOwnerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeOwnerModal.vue?vue&type=script&setup=true&lang=js"

import "./ChangeOwnerModal.vue?vue&type=style&index=0&id=c4b56e1e&lang=scss&scoped=true"
script.__scopeId = "data-v-c4b56e1e"

export default script